import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { Settings } from 'assets/assetsV1/iconComponents';

import { Divider } from 'uiToolkitV1/Divider';
import { ListRadio } from 'uiToolkitV1/ListRadio';
import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { setViewType, useCompetencySettings } from '../competencySettingsSlice';
import { Container } from './components/Container';
import { useGetCompetencySettingsQuery } from './dataHooks';

export const CompetencyAccess = () => {
  const { viewType } = useCompetencySettings();
  const { data: competencySettings, isLoading } = useGetCompetencySettingsQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    if (competencySettings) {
      dispatch(setViewType(competencySettings.viewType));
    }
  }, [competencySettings, dispatch]);

  if (isLoading) return <SkeletonLoader />;

  return (
    <Container
      title="Competency Settings"
      description="Customize how competencies are assessed to fit your organization's unique structure and needs for effective performance evaluations"
      icon={Settings}
    >
      <ListRadio
        checked={viewType === 'DISABLED'}
        label="Disable competencies"
        subText="Opt to disable competencies if your organization doesn't use them"
        onClick={() => dispatch(setViewType('DISABLED'))}
      />

      <Divider my="2px" borderColor="#EBEFF3" />

      <ListRadio
        checked={viewType === 'ORG'}
        label="Organization-wide competencies"
        subText="Establish consistent competency standards across your entire organization for a unified approach to performance assessment."
        onClick={() => dispatch(setViewType('ORG'))}
      />

      <Divider my="2px" borderColor="#EBEFF3" />

      <ListRadio
        checked={viewType === 'FUNCTION'}
        label="Function-specific competencies"
        subText="Tailor competencies to specific job functions, ensuring assessments align with the distinct requirements of different roles."
        onClick={() => dispatch(setViewType('FUNCTION'))}
      />

      <Divider my="2px" borderColor="#EBEFF3" />

      <ListRadio
        checked={viewType === 'ROLE'}
        label="Function and role-specific competencies"
        subText="Fine-tune competency assessments by customizing them for both function and role, providing a detailed and accurate evaluation approach."
        onClick={() => dispatch(setViewType('ROLE'))}
      />
    </Container>
  );
};
